// ============================================================
//  src/components/ProductImage.jsx
//
//  Single source of truth for rendering product images.
//  - Loads from /public/images/ folder
//  - Falls back to emoji if image is missing or fails to load
//  - Used in: ProductCard, ProductDetailPage, CartPage
// ============================================================

import { useState } from "react";

export default function ProductImage({  
  src,           // image path e.g. "/images/cashews.jpg"
  emoji,         // fallback emoji e.g. "🥜"
  alt,           // alt text
  color,         // product tint color for background
  height = 120,  // container height in px
  fontSize = 52, // emoji font size when used as fallback
  style = {},    // extra styles on container
  imgStyle = {}, // extra styles on <img>
}) {
  const [imgFailed, setImgFailed] = useState(false);
  const showImage = src && !imgFailed;

  return (
    <div style={{
      height,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: showImage
        ? "#fff"
        : `linear-gradient(135deg, ${color}22, ${color}44)`,
      overflow: "hidden",
      ...style,
    }}>
      {showImage ? (
        <img
          src={src}
          alt={alt}
          onError={() => setImgFailed(true)}
          style={{
            width: "auto",
            maxWidth: "100%",
            height: "100%",
            objectFit: "contain",
            display: "block",
            ...imgStyle,
          }}
        />
      ) : (
        <span style={{ fontSize, lineHeight: 1 }}>{emoji}</span>
      )}
    </div>
  );
}
